import { render } from "./ProductCarousel.vue?vue&type=template&id=4e0e3670&scoped=true&ts=true"
import script from "./ProductCarousel.vue?vue&type=script&lang=ts"
export * from "./ProductCarousel.vue?vue&type=script&lang=ts"

import "./ProductCarousel.vue?vue&type=style&index=0&id=4e0e3670&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0e3670"]])

export default __exports__